module.exports = __webpack_public_path__ + "img/link.71aefdc0.png";